import type { NotificationPresenterModule } from './NotificationPresenterModule.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as NotificationPresenterModule;
